import React, { createContext, useContext, useState } from "react";

const LanguageContext = createContext();

export const LANGUAGES = {
  EN: "en",
  VI: "vi",
};

export const translations = {
  en: {
    // Navbar
    nav: {
      home: "Home",
      about: "About",
      projects: "Projects",
      tool: "Tool",
      office: "Office",
      map: "Map",
      game: "Game",
    },

    // Home
    home: {
      greeting: "Hi There!",
      intro: "I'm",
      typeStrings: [
        "Java Backend Developer",
        "Backend Engineer",
        "Spring Boot Developer",
      ],
      introduceTitle: "LET ME",
      introduceHighlight: " INTRODUCE ",
      introduceSuffix: "MYSELF",
      body1:
        "I am a {backend} with more than {exp} building scalable {enterprise} with {java}, {springboot}, {kafka}, {postgres}, and {oracle}.",
      body2:
        "My work focuses on designing {microservices}, improving {dbperf}, and delivering reliable {distributed} for large-scale environments.",
      body3:
        "I am currently contributing to {traffic} and {gov}, where performance, stability, and maintainability are critical.",
      findMeOn: "FIND ME ON",
      connectText: "Feel free to",
      connectHighlight: "connect ",
      connectSuffix: "with me",
    },

    // About
    about: {
      profileTitle: "Professional",
      profileHighlight: "Profile",
      techTitle1Highlight: "Backend",
      techTitle1Suffix: " & Programming Languages",
      techTitle2Prefix: "Backend ",
      techTitle2H1: "Frameworks",
      techTitle2Sep: ", ",
      techTitle2H2: "Technologies",
      techTitle2Suffix: " & AI Tools",
      techTitle3Highlight: "Engineering Tools",
      techTitle3Suffix: " & Platforms",
      daysCode: "Days I",
      daysCodHighlight: "Code",

      // AboutCard
      card: {
        p1: "My name is {name}, and I am a {role} focused on building scalable, reliable, and maintainable enterprise applications.",
        p2: "With more than {exp}, I have worked extensively with {java}, {springboot}, {kafka}, {postgres}, and {oracle} to deliver backend systems that support performance-critical and large-scale business operations.",
        p3: "My professional interests include {micro}, {dbopt}, and {distributed}. I am currently contributing to projects in {traffic} and {gov}, where stability, efficiency, and long-term maintainability are essential.",
        p4: "Outside of work, I enjoy continuous learning, exploring new technologies, and improving the quality of the systems I build.",
        hobby1: "Continuous Learning",
        hobby2: "Exploring New Technologies",
        quote: '"Building reliable systems with clarity, scalability, and purpose."',
      },
    },

    // Projects
    projects: {
      title: "My Recent",
      titleHighlight: "Works",
      subtitle:
        "Here are some of the projects I built throughout my academic journey, showcasing both my technical foundation and hands-on development experience.",
      filterAll: "All",
      ghBtn: "GitHub",
      demoBtn: "Demo",
    },

    // Footer
    footer: {
      designed: "Designed and Developed by Dang Ngoc Tien",
      copyright: "Copyright © {year} Ti",
    },
  },

  vi: {
    // Navbar
    nav: {
      home: "Trang chủ",
      about: "Giới thiệu",
      projects: "Dự án",
      tool: "Công cụ",
      office: "Văn phòng",
      map: "Bản đồ",
      game: "Game",
    },

    // Home
    home: {
      greeting: "Xin chào!",
      intro: "Tôi là",
      typeStrings: [
        "Lập trình viên Backend Java",
        "Kỹ sư Backend",
        "Lập trình viên Spring Boot",
      ],
      introduceTitle: "ĐÔI NÉT",
      introduceHighlight: " VỀ ",
      introduceSuffix: "BẢN THÂN",
      body1:
        "Tôi là một {backend} với hơn {exp} xây dựng các {enterprise} mở rộng được, sử dụng {java}, {springboot}, {kafka}, {postgres} và {oracle}.",
      body2:
        "Công việc của tôi tập trung vào thiết kế {microservices}, cải thiện {dbperf}, và phát triển {distributed} đáng tin cậy cho môi trường quy mô lớn.",
      body3:
        "Hiện tôi đang đóng góp vào các dự án {traffic} và {gov}, nơi hiệu suất, sự ổn định và khả năng bảo trì là yếu tố then chốt.",
      findMeOn: "TÌM TÔI TẠI",
      connectText: "Hãy thoải mái",
      connectHighlight: "kết nối ",
      connectSuffix: "với tôi",
    },

    // About
    about: {
      profileTitle: "Hồ sơ",
      profileHighlight: "Chuyên nghiệp",
      techTitle1Highlight: "Backend",
      techTitle1Suffix: " & Ngôn ngữ lập trình",
      techTitle2Prefix: "",
      techTitle2H1: "Framework",
      techTitle2Sep: ", ",
      techTitle2H2: "Công nghệ",
      techTitle2Suffix: " & Công cụ AI",
      techTitle3Highlight: "Công cụ",
      techTitle3Suffix: " & Nền tảng kỹ thuật",
      daysCode: "Những ngày tôi",
      daysCodHighlight: "Lập trình",

      // AboutCard
      card: {
        p1: "Tôi là {name}, một {role} tập trung xây dựng các ứng dụng doanh nghiệp có khả năng mở rộng, đáng tin cậy và dễ bảo trì.",
        p2: "Với hơn {exp}, tôi đã làm việc chuyên sâu với {java}, {springboot}, {kafka}, {postgres} và {oracle} để xây dựng các hệ thống backend phục vụ các nghiệp vụ quy mô lớn và yêu cầu hiệu suất cao.",
        p3: "Lĩnh vực quan tâm của tôi bao gồm {micro}, {dbopt} và {distributed}. Hiện tôi đang tham gia các dự án về {traffic} và {gov}, nơi sự ổn định, hiệu quả và khả năng bảo trì lâu dài là yếu tố cốt lõi.",
        p4: "Ngoài công việc, tôi thích học hỏi liên tục, khám phá công nghệ mới và nâng cao chất lượng của các hệ thống mình xây dựng.",
        hobby1: "Học hỏi liên tục",
        hobby2: "Khám phá công nghệ mới",
        quote: '"Xây dựng hệ thống đáng tin cậy với sự rõ ràng, khả năng mở rộng và mục đích."',
      },
    },

    // Projects
    projects: {
      title: "Các dự án",
      titleHighlight: "Nổi bật",
      subtitle:
        "Dưới đây là một số dự án tôi đã xây dựng trong suốt quá trình học tập, thể hiện nền tảng kỹ thuật cũng như kinh nghiệm thực chiến của bản thân.",
      filterAll: "Tất cả",
      ghBtn: "GitHub",
      demoBtn: "Demo",
    },

    // Footer
    footer: {
      designed: "Thiết kế & Phát triển bởi Đặng Ngọc Tiến",
      copyright: "Bản quyền © {year} Ti",
    },
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => {
    return localStorage.getItem("portfolio_lang") || LANGUAGES.EN;
  });

  const setLanguage = (lang) => {
    setLanguageState(lang);
    localStorage.setItem("portfolio_lang", lang);
  };

  const t = translations[language];

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
